export default "__VITE_ASSET__vw__9jQT__"